"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../../config/types");
const onchainPoolToken_1 = __importDefault(require("../../onchainPoolToken"));
class OnchainCollateral extends onchainPoolToken_1.default {
    constructor(lendingPool) {
        super();
        this.collateralCache = {};
        this.getLendingPool = () => this.lendingPool;
        this.getContractHelper = () => this.lendingPool.getImpermaxFactory().getOnchain().getContractHelper();
        this.getOffchainCollateral = this.getOffchainPoolToken;
        this.lendingPool = lendingPool;
    }
    cleanCache() {
        super.cleanCache();
        this.collateralCache = {};
    }
    getPoolTokenAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.lendingPool.getPoolTokenAddresses())[types_1.PoolTokenType.Collateral];
        });
    }
    getOffchainPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPool = yield this.lendingPool.getOffchainLendingPool();
            return lendingPool.getCollateral();
        });
    }
    initializePoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getContractHelper().newCollateral(yield this.getPoolTokenAddress());
        });
    }
    initializeToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.lendingPool.getUniswapV2Pair();
        });
    }
    initializeExchangeRate() {
        const _super = Object.create(null, {
            initializeExchangeRate: { get: () => super.initializeExchangeRate }
        });
        return __awaiter(this, void 0, void 0, function* () {
            let exchangeRate = yield _super.initializeExchangeRate.call(this);
            return exchangeRate * (yield this.lendingPool.getStakedLPExchangeRate());
        });
    }
}
exports.default = OnchainCollateral;
